module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_vestland_neg.2159bb67.svg";